import { getDefaultHomeRole, useHomeRole } from "components/materials/home/use-home-role";
import { useAppSelector } from "store/index";
import { selectLastHomeRole } from "store/selectors";
import { homeUrlForRole } from "utils/urls";

export const useHomeUrl = () => {
  const lastHomeRole = useAppSelector(selectLastHomeRole);
  const { availableRoles } = useHomeRole();

  if (lastHomeRole && availableRoles.includes(lastHomeRole)) {
    return homeUrlForRole(lastHomeRole);
  }

  return homeUrlForRole(getDefaultHomeRole(availableRoles));
};
